import { devtools, persist } from 'zustand/middleware';
import { UserStore } from '@/store/user';
import { NavigateFunction } from 'react-router-dom';
import { getSettingsBranch, getSettingsCompany } from '@/services/settings';
import { QueryClient } from '@tanstack/react-query';
import { create } from 'zustand';

export const SettingStore = create<{
  getSettingBranch: ({
    navigate,
    queryClient,
  }: {
    navigate?: NavigateFunction;
    queryClient: QueryClient;
  }) => Promise<void>;
  getSettingCompany: ({
    navigate,
    queryClient,
  }: {
    navigate?: NavigateFunction;
    queryClient: QueryClient;
  }) => Promise<void>;
  logoBs64: string;
  setting: any;
  permissions: any;
}>()(
  devtools(
    persist(
      (set, get) => ({
        setting: null,
        logoBs64: '',
        permissions: null,
        getSettingCompany: async ({ navigate, queryClient }) => {
          const { user } = UserStore.getState();
          if (user?.companySelected?.id) {
            try {
              const companySetting = await getSettingsCompany(user.companySelected.id)();
              const validateLogo = /^https?:\/\/.+(\.jpg|\.jpeg|\.png|\.gif|\.bmp)$/i;
              let { logo } = companySetting;
              if (!validateLogo.test(companySetting.logo)) {
                const logoResolve = await fetch(companySetting.logo);
                const logoBs64 = await logoResolve.blob();
                logo = URL.createObjectURL(logoBs64);
              }
              set(() => ({
                setting: { ...companySetting },
                needSetting: false,
                logoBs64: logo,
              }));
            } catch (e) {
              const newErrorObjet = {
                logoBs64: '',
                setting: null,
              };
              set(() => ({
                ...newErrorObjet,
              }));
            } finally {
              await queryClient.invalidateQueries();
            }
          }
        },
        getSettingBranch: async ({ navigate, queryClient }) => {
          const { user } = UserStore.getState();
          const previousSettings: any = get().setting;
          if (user?.companySelected?.id) {
            try {
              if (Object.keys(previousSettings ?? {}).length) {
                const branchSetting = user.branchSelected
                  ? await getSettingsBranch(user.branchSelected.id)()
                  : null;
                set((prev) => ({
                  ...prev,
                  setting: { ...previousSettings, ...(branchSetting && { branch: branchSetting }) },
                }));
              }
            } catch (e) {
              if (Object.keys(previousSettings ?? {}).length) {
                set((prev) => ({
                  ...prev,
                  setting: { ...(previousSettings as any), branch: null },
                }));
              }
            } finally {
              await queryClient.invalidateQueries();
            }
          }
        },
      }),
      {
        name: 'setting-storage',
      }
    )
  )
);
